import React from 'react';
import './styles/style.css'; 

interface FormBlockProps {
    title: string;
    children: React.ReactNode;
    showBadge?: boolean;
    badgeText?: string | number;
    badgeVariant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'grey' | 'info';
}

export const FormBlock: React.FC<FormBlockProps> = ({ 
    title, 
    children, 
    showBadge = false,
    badgeText,
    badgeVariant = 'secondary'
}) => {
    return (
        <div className="form-block">
            <h6 className="form-block-title">
                {showBadge && badgeText && (
                    <span className={`form-block-badge badge-${badgeVariant}`}>
                        {badgeText}
                    </span>
                )}
                {title}
            </h6>
            {children}
        </div>
    );
};